















































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import api from '@/helpers/fetch'
import logoLocatelli from '@/assets/logo-locatelli-min.png'
import DrivePanel from '@/components/SART/DrivePanel.vue'
import JSZip from 'jszip'
import {
	Chart,
	BarController,
	BarElement,
	CategoryScale,
	LinearScale,
	Tooltip,
	Legend,
} from 'chart.js'

Chart.register(
	BarController,
	BarElement,
	CategoryScale,
	LinearScale,
	Tooltip,
	Legend,
)

// ── Constantes de cor ────────────────────────────────────────────────────────
const T = '#1A4F63'
const O = '#E84E1B'

// ── Config de alíquotas ──────────────────────────────────────────────────────
const CONFIG_DEFAULTS = {
	CBS: 8.8,
	IBS: 17.7,
	get total() {
		return +(this.CBS + this.IBS).toFixed(2)
	},
	creditoEfetivo: 60,
	prazoFloatDias: 25,
	taxaCapitalGiro: 14,
	normas: 'EC 132/2023 · LC 214/2025 · LC 227/2026',
}

// ── Tabela de transição 2026-2033 ────────────────────────────────────────────
const TRANSICAO: Record<
	number,
	{
		CBS_fator: number
		IBS_fator: number
		ICMS_ISS_fator: number
		PIS_COF_fator: number
	}
> = {
	2026: {
		CBS_fator: 0.009 / 0.088,
		IBS_fator: 0.001 / 0.177,
		ICMS_ISS_fator: 1.0,
		PIS_COF_fator: 1.0,
	},
	2027: {
		CBS_fator: 1.0,
		IBS_fator: 0.001 / 0.177,
		ICMS_ISS_fator: 1.0,
		PIS_COF_fator: 0,
	},
	2028: {
		CBS_fator: 1.0,
		IBS_fator: 0.001 / 0.177,
		ICMS_ISS_fator: 1.0,
		PIS_COF_fator: 0,
	},
	2029: {
		CBS_fator: 1.0,
		IBS_fator: 0.1,
		ICMS_ISS_fator: 0.9,
		PIS_COF_fator: 0,
	},
	2030: {
		CBS_fator: 1.0,
		IBS_fator: 0.2,
		ICMS_ISS_fator: 0.8,
		PIS_COF_fator: 0,
	},
	2031: {
		CBS_fator: 1.0,
		IBS_fator: 0.4,
		ICMS_ISS_fator: 0.6,
		PIS_COF_fator: 0,
	},
	2032: {
		CBS_fator: 1.0,
		IBS_fator: 0.6,
		ICMS_ISS_fator: 0.4,
		PIS_COF_fator: 0,
	},
	2033: {
		CBS_fator: 1.0,
		IBS_fator: 1.0,
		ICMS_ISS_fator: 0,
		PIS_COF_fator: 0,
	},
}

const DISCLAIMER = `Alíquotas de referência CBS ${CONFIG_DEFAULTS.CBS}% / IBS ${CONFIG_DEFAULTS.IBS}% são estimativas baseadas na EC 132/2023 e LC 214/2025. Os valores definitivos serão fixados por Resolução do Senado Federal.`

const SEC_TITLES: Record<string, string> = {
	sumario: '1. Sumário Executivo',
	credito: '2. O Crédito — A Principal Mudança',
	diagnostico: '3. Diagnóstico da Carga Atual',
	impacto: '4. Análise de Impacto CBS e IBS',
	splitpayment: '5. Split Payment — Fluxo de Caixa',
	fornecedores: '6. Cadeia de Fornecedores',
	roadmap: '7. Roadmap de Transição e Recomendações',
}

// ── Utilitários ──────────────────────────────────────────────────────────────
const fmt = (n: number) => Math.round(n || 0).toLocaleString('pt-BR')
const fmtR = (n: number) => `R$ ${fmt(n)}`
const today = () =>
	new Date().toLocaleDateString('pt-BR', {
		day: '2-digit',
		month: 'long',
		year: 'numeric',
	})

// ── parseSPED ────────────────────────────────────────────────────────────────
function parseSPED(text: string) {
	const lines = text.split(/\r?\n/).filter((l) => l.includes('|'))
	const g = (l: string) =>
		l
			.split('|')
			.slice(1)
			.map((s) => s.trim())
	const pf = (s: string) => parseFloat((s || '0').replace(',', '.')) || 0
	let empresa = { nome: '', cnpj: '' }
	let periodo = { ini: '', fim: '' }
	let receita = 0
	let icms = 0
	let iss = 0
	let pisD = 0
	let cofinsD = 0
	let pisC = 0
	let cofinsC = 0
	let notas = 0
	for (const line of lines) {
		const f = g(line)
		switch (f[0]) {
			case '0000':
				empresa = { nome: f[6] || '', cnpj: f[7] || '' }
				periodo = { ini: f[3] || '', fim: f[4] || '' }
				break
			case 'C100':
				if (f[1] === '1') {
					receita += pf(f[11])
					icms += pf(f[21])
					notas++
				}
				break
			case 'A100':
				receita += pf(f[6])
				iss += pf(f[14])
				break
			case 'M200':
				pisD = pf(f[12])
				pisC = pf(f[2])
				break
			case 'M600':
				cofinsD = pf(f[12])
				cofinsC = pf(f[2])
				break
		}
	}
	const pis = pisD || receita * 0.0165
	const cofins = cofinsD || receita * 0.076
	return {
		empresa,
		periodo,
		receita,
		pis,
		cofins,
		icms,
		iss,
		pisC,
		cofinsC,
		notas,
		parsed: true,
	}
}

// ── rulesEngine ──────────────────────────────────────────────────────────────
function rulesEngine(
	sped: any,
	regime: string,
	cfg: typeof CONFIG_DEFAULTS = CONFIG_DEFAULTS,
) {
	const r = sped.receita || 1_500_000
	const pis = sped.pis || r * 0.0165
	const cofins = sped.cofins || r * 0.076
	const icms = sped.icms || r * (regime === 'LUCRO_REAL' ? 0.12 : 0.08)
	const iss = sped.iss || 0
	const cAtual = pis + cofins + icms + iss

	const fatorCredito = (100 - cfg.creditoEfetivo) / 100
	const cbsL = r * (cfg.CBS / 100) * (1 - fatorCredito)
	const ibsL = r * (cfg.IBS / 100) * (1 - fatorCredito)
	const cNova = cbsL + ibsL
	const varPct = (((cNova - cAtual) / cAtual) * 100).toFixed(1)

	const float = ((pis + cofins) * cfg.prazoFloatDias) / 30
	const custoFloat = float * (cfg.taxaCapitalGiro / 100)

	const anos = Object.keys(TRANSICAO).map(Number)
	const projecao = anos.map((ano) => {
		const t = TRANSICAO[ano]
		const cbs = Math.round(
			r * (cfg.CBS / 100) * t.CBS_fator * (1 - fatorCredito),
		)
		const ibs = Math.round(
			r * (cfg.IBS / 100) * t.IBS_fator * (1 - fatorCredito),
		)
		const leg = Math.round(
			(icms + iss) * t.ICMS_ISS_fator + (pis + cofins) * t.PIS_COF_fator,
		)
		return {
			ano,
			CBS: cbs,
			IBS: ibs,
			'ICMS/ISS': leg,
			Total: cbs + ibs + leg,
		}
	})

	return {
		receita: r,
		cAtual: Math.round(cAtual),
		pctAtual: ((cAtual / r) * 100).toFixed(1),
		pis: Math.round(pis),
		cofins: Math.round(cofins),
		icms: Math.round(icms),
		iss: Math.round(iss),
		cbsL: Math.round(cbsL),
		ibsL: Math.round(ibsL),
		cNova: Math.round(cNova),
		varPct,
		float: Math.round(float),
		custoFloat: Math.round(custoFloat),
		projecao,
		pisC: Math.round(sped.pisC || 0),
		cofinsC: Math.round(sped.cofinsC || 0),
	}
}

export default Vue.extend({
	name: 'SART',

	components: { DrivePanel },

	data() {
		return {
			T,
			O,
			CONFIG: { ...CONFIG_DEFAULTS } as typeof CONFIG_DEFAULTS,
			DISCLAIMER,
			logoSrc: logoLocatelli as string,
			view: 'dashboard' as string,
			wiz: 0,
			client: {
				nome: '',
				cnpj: '',
				regime: 'LUCRO_PRESUMIDO',
				porte: 'MEDIO',
				setor: '',
				advogado: '',
				destinatario: '',
			},
			spedFiles: [] as File[],
			spedDataList: [] as any[],
			calc: null as any,
			sections: {} as Record<string, string>,
			editing: null as string | null,
			loading: false,
			loadMsg: '',
			history: [] as any[],
			activeReport: null as any,
			chart: null as any,
			exportandoPDF: false,
			erroPDF: null as string | null,
			driveContext: null as { docs: any[]; fullContext: string } | null,
			regimeLabel: {
				SIMPLES: 'Simples Nacional',
				LUCRO_PRESUMIDO: 'Lucro Presumido',
				LUCRO_REAL: 'Lucro Real',
			} as Record<string, string>,
			porteLabel: {
				ME_EPP: 'ME / EPP',
				MEDIO: 'Médio porte',
				GRANDE: 'Grande porte',
			} as Record<string, string>,
			navItems: [
				{ id: 'dashboard', label: 'Dashboard' },
				{ id: 'new', label: 'Nova análise' },
				{ id: 'history', label: 'Histórico' },
			],
			wizardSteps: ['Dados do cliente', 'Upload SPED', 'Processamento'],
			histHeaders: [
				'Cliente',
				'CNPJ',
				'Regime',
				'Carga atual',
				'Carga nova',
				'Variação',
				'Data',
				'',
			],
			creditoItems: [
				{
					title: 'Crédito físico restrito (atual)',
					desc: 'Apenas insumos que integram fisicamente o produto',
				},
				{
					title: 'Crédito financeiro pleno (CBS/IBS)',
					desc: 'Qualquer aquisição onerada gera crédito — sem lista restritiva',
				},
				{
					title: 'Serviços, fretes, aluguéis, energia',
					desc: 'Passam a gerar crédito integral a partir de 2027',
				},
				{
					title: 'Ressarcimento de saldo credor',
					desc: 'Em até 60 dias (exportadores: 30 dias)',
				},
			],
			cronogramaItems: [
				{
					ano: '2026',
					desc: `CBS ${CONFIG_DEFAULTS.CBS}%×0,1 + IBS ${CONFIG_DEFAULTS.IBS}%×0,006 (teste)`,
					color: O,
				},
				{
					ano: '2027',
					desc: 'Extinção PIS/COFINS — CBS plena entra em vigor',
					color: T,
				},
				{
					ano: '2029–2032',
					desc: 'Redução gradual ICMS/ISS (–20% ao ano)',
					color: T,
				},
				{
					ano: '2033',
					desc: 'Sistema definitivo CBS+IBS — ICMS e ISS extintos',
					color: '#1E7A45',
				},
			],
			normasItems: [
				{
					nome: 'EC 132/2023',
					desc: 'Estrutura constitucional CBS/IBS/IS e período de transição 2026–2033',
				},
				{
					nome: 'LC 214/2025',
					desc: 'Incidência, crédito financeiro pleno, alíquotas, Split Payment e regimes especiais',
				},
				{
					nome: 'LC 227/2026',
					desc: 'CGIBS, processo administrativo do IBS, normas ITCMD e ajustes à LC 214/2025',
				},
			],
		}
	},

	computed: {
		spedData(): any {
			if (!this.spedDataList.length) return null
			if (this.spedDataList.length === 1) return this.spedDataList[0]
			// Consolidate multiple SPED files
			const base = this.spedDataList[0]
			return this.spedDataList.slice(1).reduce(
				(acc: any, d: any) => ({
					...acc,
					receita: acc.receita + d.receita,
					pis: acc.pis + d.pis,
					cofins: acc.cofins + d.cofins,
					icms: acc.icms + d.icms,
					iss: acc.iss + d.iss,
					pisC: acc.pisC + d.pisC,
					cofinsC: acc.cofinsC + d.cofinsC,
					notas: acc.notas + d.notas,
				}),
				{ ...base },
			)
		},
		spedFile(): File | null {
			return this.spedFiles[0] || null
		},
		disclaimer(): string {
			return `Alíquotas de referência CBS ${this.CONFIG.CBS}% / IBS ${this.CONFIG.IBS}% são estimativas baseadas na EC 132/2023 e LC 214/2025. Os valores definitivos serão fixados por Resolução do Senado Federal.`
		},

		viewTitle(): string {
			const map: Record<string, string> = {
				dashboard: 'Dashboard',
				new: 'Nova análise',
				history: 'Histórico de análises',
				report: 'Relatório',
			}
			return map[this.view] || ''
		},

		secTitleEntries(): [string, string][] {
			return Object.entries(SEC_TITLES)
		},

		dashboardMetrics(): any[] {
			return [
				{
					label: 'Análises realizadas',
					value: this.history.length,
					sub: 'nesta sessão',
				},
				{
					label: `CBS (ref.)`,
					value: `${this.CONFIG.CBS}%`,
					sub: 'sujeita à Resolução Senado',
					color: O,
				},
				{
					label: `IBS (ref.)`,
					value: `${this.CONFIG.IBS}%`,
					sub: 'sujeita à Resolução Senado',
					color: O,
				},
				{
					label: 'Sistema definitivo',
					value: '2033',
					sub: 'extinção ICMS e ISS',
				},
			]
		},

		reportMetrics(): any[] {
			if (!this.calc) return []
			return [
				{ label: 'Receita base', value: fmtR(this.calc.receita) },
				{
					label: 'Carga atual',
					value: fmtR(this.calc.cAtual),
					sub: this.calc.pctAtual + '% da receita',
				},
				{ label: 'Carga nova (CBS+IBS)', value: fmtR(this.calc.cNova) },
				{
					label: 'Variação',
					value:
						(parseFloat(this.calc.varPct) > 0 ? '+' : '') +
						this.calc.varPct +
						'%',
					color: parseFloat(this.calc.varPct) < 0 ? '#27AE60' : O,
				},
				{
					label: 'Float perdido/mês',
					value: fmtR(this.calc.float),
					sub: 'Split Payment',
					color: O,
				},
			]
		},

		reportIdentRows(): any[] {
			const c =
				(this.activeReport && this.activeReport.client) || this.client
			return [
				{ k: 'Elaborado para', v: c.destinatario || c.nome },
				{ k: 'CNPJ', v: c.cnpj },
				{ k: 'Regime', v: this.regimeLabel[c.regime] },
				{ k: 'Porte', v: this.porteLabel[c.porte] },
				{
					k: 'Advogado responsável',
					v: c.advogado || 'Locatelli Advogados',
				},
				{ k: 'Data de emissão', v: today() },
			]
		},

		spedDataItems(): any[] {
			if (!this.spedData) return []
			const s = this.spedData
			return [
				{
					k: 'Período',
					v:
						s.periodo && s.periodo.ini
							? `${s.periodo.ini}–${s.periodo.fim}`
							: '—',
				},
				{ k: 'Notas lidas', v: s.notas || '—' },
				{ k: 'Receita', v: s.receita ? fmtR(s.receita) : '—' },
				{ k: 'PIS', v: s.pis ? fmtR(s.pis) : '—' },
				{ k: 'COFINS', v: s.cofins ? fmtR(s.cofins) : '—' },
				{ k: 'ICMS', v: s.icms ? fmtR(s.icms) : '—' },
			]
		},

		confirmItems(): string[] {
			return [
				'Dados do cliente validados ✓',
				this.spedFiles.length
					? `${this.spedFiles.length} SPED(s): ${this.spedFiles.map((f) => f.name).join(', ')} ✓`
					: 'Modo demonstração (sem SPED) ✓',
				`${this.CONFIG.normas} ✓`,
				`CBS ${this.CONFIG.CBS}% / IBS ${this.CONFIG.IBS}% configurados ✓`,
				'Rules Engine + crédito financeiro pleno ✓',
			]
		},
	},

	watch: {
		view(val: any) {
			if (val === 'report') {
				this.$nextTick(() => this.initChart())
			}
		},
	},

	beforeDestroy() {
		if (this.chart) this.chart.destroy()
	},

	async mounted() {
		try {
			const cfg = await api.get('/api/sart/admin/config')
			if (cfg && cfg.cbs) {
				this.CONFIG = {
					CBS: parseFloat(cfg.cbs),
					IBS: parseFloat(cfg.ibs),
					get total() {
						return +(this.CBS + this.IBS).toFixed(2)
					},
					creditoEfetivo: parseFloat(cfg.creditoEfetivo ?? 60),
					prazoFloatDias: parseFloat(cfg.prazoFloatDias ?? 25),
					taxaCapitalGiro: parseFloat(cfg.taxaCapitalGiro ?? 14),
					normas: 'EC 132/2023 · LC 214/2025 · LC 227/2026',
				}
			}
		} catch (e) {
			console.warn('[SART] Usando config padrão:', e)
		}
	},

	methods: {
		fmtR,

		switchView(id: string) {
			this.view = id
			if (id === 'new') this.wiz = 0
		},

		fmtCNPJ(v: string) {
			return v
				.replace(/\D/g, '')
				.slice(0, 14)
				.replace(/(\d{2})(\d)/, '$1.$2')
				.replace(/(\d{3})(\d)/, '$1.$2')
				.replace(/(\d{3})(\d)/, '$1/$2')
				.replace(/(\d{4})(\d)/, '$1-$2')
		},

		handleFileChange(e: Event) {
			const input = e.target as HTMLInputElement
			if (!input.files?.length) return
			this.addFiles(Array.from(input.files))
			input.value = ''
		},

		handleDrop(e: DragEvent) {
			const files = e.dataTransfer?.files
			if (!files?.length) return
			this.addFiles(Array.from(files))
		},

		async addFiles(files: File[]) {
			for (const file of files) {
				const ext = file.name.toLowerCase()
				if (ext.endsWith('.zip')) {
					await this.extractZip(file)
				} else if (ext.endsWith('.txt') || ext.endsWith('.sped')) {
					await this.processSpedFile(file)
				}
			}
		},

		async extractZip(zipFile: File) {
			try {
				const zip = await JSZip.loadAsync(zipFile)
				const txts: any[] = []
				zip.forEach((_path: string, entry: any) => {
					const name = entry.name.split('/').pop() || entry.name
					if (
						!entry.dir &&
						(name.startsWith('ESCRITURACAO-') ||
							name.toLowerCase().endsWith('.txt') ||
							name.toLowerCase().endsWith('.sped'))
					) {
						txts.push(entry)
					}
				})
				for (const entry of txts) {
					const blob = await entry.async('blob')
					const name = entry.name.split('/').pop() || entry.name
					const file = new File([blob], name, { type: 'text/plain' })
					await this.processSpedFile(file)
				}
			} catch (err) {
				console.error('[SART] Erro ao extrair ZIP:', err)
			}
		},

		async processSpedFile(f: File) {
			// Prevent duplicates
			if (
				this.spedFiles.find(
					(x) => x.name === f.name && x.size === f.size,
				)
			) {
				return
			}

			const text = await new Promise<string>((resolve, reject) => {
				const reader = new FileReader()
				reader.onload = (ev) => resolve(ev.target?.result as string)
				reader.onerror = reject
				reader.readAsText(f, 'latin1')
			})
			const d = parseSPED(text)
			this.spedFiles = [...this.spedFiles, f]
			this.spedDataList = [...this.spedDataList, d]
			// Auto-fill client name from first file
			if (
				this.spedFiles.length === 1 &&
				d.empresa.nome &&
				!this.client.nome
			) {
				this.client = {
					...this.client,
					nome: d.empresa.nome,
					cnpj: this.fmtCNPJ(d.empresa.cnpj),
				}
			}
		},

		removeSpedFile(index: number) {
			this.spedFiles = this.spedFiles.filter((_, i) => i !== index)
			this.spedDataList = this.spedDataList.filter((_, i) => i !== index)
		},

		downloadSpedFile(index: number) {
			const file = this.spedFiles[index]
			if (!file) return
			const url = URL.createObjectURL(file)
			const a = document.createElement('a')
			a.href = url
			a.download = file.name
			document.body.appendChild(a)
			a.click()
			document.body.removeChild(a)
			URL.revokeObjectURL(url)
		},

		async runAnalysis() {
			this.loading = true
			const msgs = [
				'Lendo blocos do SPED (0, A, C, M, P)…',
				'Calculando carga tributária atual…',
				`Projetando CBS ${this.CONFIG.CBS}% e IBS ${this.CONFIG.IBS}% com crédito financeiro pleno…`,
				'Modelando transição 2026–2033 com fatores EC 132/2023…',
				'Calculando impacto do Split Payment no capital de giro…',
				'Analisando crédito presumido da cadeia de fornecedores…',
				'Gerando relatório personalizado com IA…',
			]
			const sd = this.spedData || {
				receita: 0,
				pis: 0,
				cofins: 0,
				icms: 0,
				iss: 0,
				pisC: 0,
				cofinsC: 0,
				notas: 0,
				parsed: false,
			}
			const c = rulesEngine(sd, this.client.regime, this.CONFIG)
			this.calc = c
			for (const m of msgs) {
				this.loadMsg = m
				await new Promise((resolve) => setTimeout(resolve, 700))
			}
			try {
				const s = await this.gerarRascunho(this.client, c)
				this.sections = s
				const entry = {
					id: Date.now(),
					client: { ...this.client },
					calc: c,
					sections: s,
					date: today(),
				}
				this.history = [entry, ...this.history]
				this.activeReport = entry
			} catch (e) {
				this.sections = {
					sumario:
						'Erro ao conectar com a IA. Verifique sua conexão e tente novamente.',
					credito: '',
					diagnostico: '',
					impacto: '',
					splitpayment: '',
					fornecedores: '',
					roadmap: '',
				}
			}
			this.loading = false
			this.view = 'report'
		},

		async gerarRascunho(client: any, calc: any) {
			const porteL: Record<string, string> = {
				ME_EPP: 'ME / EPP',
				MEDIO: 'Médio porte',
				GRANDE: 'Grande porte',
			}
			const prompt = `Gere relatório executivo de impacto da Reforma Tributária para:

Cliente: ${client.nome} | CNPJ: ${client.cnpj}
Regime: ${porteL[client.porte] || client.regime} | Setor: ${client.setor || 'Comércio e Serviços'}
Advogado responsável: ${client.advogado || 'Locatelli Advogados'}

Base normativa: ${this.CONFIG.normas}
Alíquotas de referência: CBS ${this.CONFIG.CBS}% / IBS ${this.CONFIG.IBS}% / Total ${this.CONFIG.total}%
ATENÇÃO: estas alíquotas são estimativas - incluir disclaimer em todo número calculado.

Dados calculados pelo sistema:
- Receita bruta anualizada: ${fmtR(calc.receita)}/ano
- Carga tributária atual: ${fmtR(calc.cAtual)} (${calc.pctAtual}% da receita)
   PIS: ${fmtR(calc.pis)} | COFINS: ${fmtR(calc.cofins)} | ICMS: ${fmtR(calc.icms)} | ISS: ${fmtR(calc.iss)}
- CBS projetada (com crédito financeiro pleno): ${fmtR(calc.cbsL)}
- IBS projetado (com crédito financeiro pleno): ${fmtR(calc.ibsL)}
- Carga nova total: ${fmtR(calc.cNova)} | Variação: ${calc.varPct}%
- Float tributário atual (a ser eliminado pelo Split Payment): ${fmtR(calc.float)}/mês
- Custo financeiro anual da perda do float (${this.CONFIG.taxaCapitalGiro}% a.a.): ${fmtR(calc.custoFloat)}

ÊNFASE OBRIGATÓRIA: A principal mudança da reforma é o CRÉDITO FINANCEIRO PLENO
(arts. 57-86, LC 214/2025). Qualquer aquisição onerada por CBS/IBS gera crédito -
sem lista restritiva, sem discussão de insumos. Isso representa expansão significativa
frente ao crédito restrito do PIS/COFINS não-cumulativo atual.

Responda SOMENTE com JSON válido (sem markdown):
{
  "sumario": "2 parágrafos executivos com os 3 números-chave. Ênfase no crédito financeiro pleno como principal impacto positivo. Disclaimer de alíquotas provisórias ao final.",
  "credito": "2-3 parágrafos detalhados sobre o crédito financeiro pleno: o que muda, o que passa a gerar crédito (serviços, fretes, aluguéis, energia), comparação com o sistema atual restrito, impacto prático estimado. Citar arts. 57-86, LC 214/2025.",
  "diagnostico": "2 parágrafos sobre carga tributária atual por tributo, créditos aproveitados e posição fiscal.",
  "impacto": "2-3 parágrafos: projeção CBS vs PIS/COFINS, IBS vs ICMS/ISS, efeito líquido com crédito pleno. Tabela textual 2026-2033. Disclaimer de alíquotas.",
  "splitpayment": "1-2 parágrafos: mecanismo, quantificação do float perdido em R$, 3 recomendações concretas de mitigação.",
  "fornecedores": "2 parágrafos: crédito presumido reduzido para fornecedores no Simples Nacional, impacto em R$, recomendação de mapeamento. Citar arts. 117-127, LC 214/2025 e LC 227/2026.",
  "roadmap": "Roadmap em 4 horizontes - AÇÃO | MOTIVO | RESPONSÁVEL | PRAZO para cada item."
}`

			// Bloco de contexto do Drive (opcional)
			const driveBlock = this.driveContext?.fullContext
				? `\n\nBASE NORMATIVA ATUALIZADA (documentos selecionados do Drive — use como referência prioritária):\n${this.driveContext.fullContext}`
				: ''

			const d = await api.post('/api/assistente-juridico', {
				messages: [{ role: 'user', content: prompt + driveBlock }],
			})
			const raw = ((d.content || []) as any[])
				.map((b: any) => b.text || '')
				.join('')
				.replace(/```json|```/g, '')
				.trim()
			return JSON.parse(raw)
		},

		onDriveContext(ctx: { docs: any[]; fullContext: string } | null) {
			this.driveContext = ctx
		},

		openReport(entry: any) {
			this.activeReport = entry
			this.sections = { ...entry.sections }
			this.client = { ...entry.client }
			this.calc = entry.calc
			this.view = 'report'
		},

		restoreSection(key: string) {
			if (this.activeReport && this.activeReport.sections) {
				this.sections = {
					...this.sections,
					[key]: this.activeReport.sections[key] || '',
				}
			}
		},

		async doExportDocx() {
			const clientData =
				(this.activeReport && this.activeReport.client) || this.client
			try {
				const res = await fetch('/api/sart/export-docx', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					credentials: 'include',
					body: JSON.stringify({
						client: clientData,
						sections: this.sections,
						calc: this.calc,
					}),
				})
				if (!res.ok) throw new Error(`Erro ${res.status}`)
				const blob = await res.blob()
				const url = URL.createObjectURL(blob)
				const a = document.createElement('a')
				const safeName = (clientData.nome || 'Relatorio').replace(
					/\s+/g,
					'_',
				)
				a.href = url
				a.download = `Locatelli_Reforma_${safeName}.docx`
				document.body.appendChild(a)
				a.click()
				document.body.removeChild(a)
				URL.revokeObjectURL(url)
			} catch (e: any) {
				alert('Não foi possível gerar o Word: ' + e.message)
			}
		},

		async exportarPDF() {
			if (this.exportandoPDF) return
			this.exportandoPDF = true
			this.erroPDF = null
			try {
				const clientData =
					(this.activeReport && this.activeReport.client) ||
					this.client
				const body = {
					relatorio: {
						sumario: this.sections.sumario || '',
						credito: this.sections.credito || '',
						diagnostico: this.sections.diagnostico || '',
						impacto: this.sections.impacto || '',
						splitpayment: this.sections.splitpayment || '',
						fornecedores: this.sections.fornecedores || '',
						roadmap: this.sections.roadmap || '',
						tabelaTransicao: this.tabelaTransicaoParaPDF(),
					},
					config: {
						cbs: this.CONFIG.CBS,
						ibs: this.CONFIG.IBS,
					},
					cliente: {
						razaoSocial:
							clientData.destinatario || clientData.nome || '',
						cnpj: clientData.cnpj || '',
					},
				}
				const resp = await fetch('/api/sart/pdf/export', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					credentials: 'include',
					body: JSON.stringify(body),
				})
				if (!resp.ok) {
					const err = await resp
						.json()
						.catch(() => ({ error: 'Erro desconhecido' }))
					throw new Error(err.error || `HTTP ${resp.status}`)
				}
				const blob = await resp.blob()
				const url = URL.createObjectURL(blob)
				const a = document.createElement('a')
				a.href = url
				a.download = `Locatelli_RTC_${new Date().toISOString().slice(0, 10)}.pdf`
				document.body.appendChild(a)
				a.click()
				document.body.removeChild(a)
				URL.revokeObjectURL(url)
			} catch (err: any) {
				console.error('[exportarPDF]', err)
				this.erroPDF = `Erro ao gerar PDF: ${err.message}`
			} finally {
				this.exportandoPDF = false
			}
		},

		tabelaTransicaoParaPDF() {
			const fatores: Record<number, number> = {
				2026: 0.1,
				2027: 0.2,
				2028: 0.3,
				2029: 0.4,
				2030: 0.5,
				2031: 0.6,
				2032: 0.7,
				2033: 1.0,
			}
			const cbs = parseFloat(String(this.CONFIG.CBS))
			const ibs = parseFloat(String(this.CONFIG.IBS))
			return {
				headers: ['Ano', 'CBS (%)', 'IBS (%)', 'Total (%)', 'Fator'],
				colWidths: [50, 80, 80, 80, 70],
				rows: Object.entries(fatores).map(([ano, fator]) => [
					ano,
					(cbs * fator).toFixed(2),
					(ibs * fator).toFixed(2),
					((cbs + ibs) * fator).toFixed(2),
					`${(fator * 100).toFixed(0)}%`,
				]),
			}
		},

		initChart() {
			if (!this.calc || !this.calc.projecao) return
			const canvas = this.$refs.chartCanvas as HTMLCanvasElement
			if (!canvas) return
			if (this.chart) {
				this.chart.destroy()
				this.chart = null
			}

			const projecao = this.calc.projecao
			this.chart = new Chart(canvas, {
				type: 'bar',
				data: {
					labels: projecao.map((p: any) => p.ano),
					datasets: [
						{
							label: 'CBS',
							data: projecao.map((p: any) => p.CBS),
							backgroundColor: T,
							borderRadius: 2,
						},
						{
							label: 'IBS',
							data: projecao.map((p: any) => p.IBS),
							backgroundColor: O,
							borderRadius: 2,
						},
						{
							label: 'ICMS/ISS',
							data: projecao.map((p: any) => p['ICMS/ISS']),
							backgroundColor: '#8FA8B4',
							borderRadius: 2,
						},
					],
				},
				options: {
					responsive: true,
					maintainAspectRatio: false,
					plugins: {
						legend: { labels: { font: { size: 11 } } },
						tooltip: {
							callbacks: {
								label: (ctx: any) =>
									`${ctx.dataset.label}: ${fmtR(ctx.raw)}`,
							},
						},
					},
					scales: {
						x: { ticks: { font: { size: 11 }, color: '#89AABB' } },
						y: {
							ticks: {
								font: { size: 10 },
								color: '#89AABB',
								callback: (v: any) =>
									`${(+v / 1000).toFixed(0)}k`,
							},
						},
					},
				},
			})
		},
	},
})
